import React from "react";
import { getImageKitUrl } from "../../../util/utility";

const QUOTE_ICONS = {
  vm_quote_call: "https://vmnk.gumlet.io/Call.svg",
  vm_quote_review: "https://vmnk.gumlet.io/Review.svg",
  vm_quote_manage: "https://vmnk.gumlet.io/Manager.svg",
  vm_quote_background_image: "https://vmnk.gumlet.io/getquoteimage.svg",
  vm_quote_get_call_banner: "https://vmnk.gumlet.io/Get_a_Call_Now_Desktop.svg",
  vm_thank_you_gif: getImageKitUrl("https://vmnk.gumlet.io/ThankyouMakeupartist.gif"),
  vm_get_quote_venue_thankyou_image: getImageKitUrl("https://vmnk.gumlet.io/get-quote-venue.svg"),
};

function Icon({ iconName, className = "", style = {} }) {
  const src = QUOTE_ICONS[iconName];
  if (!src) return null;
  return <img src={src} alt="" className={className} style={style} />;
}

export default Icon;
